import React from 'react';

function QuickActions({ onOpenTaskCreator, onOpenRoutineBuilder, onOpenWorkoutTracker }) {
  return (
    <div className="quick-add">
      <button onClick={onOpenTaskCreator} className="add-task-btn">
        🐾 Add Task
      </button>
      <button onClick={onOpenRoutineBuilder} className="add-routine-btn">
        💪 Build Routine
      </button>
      <button onClick={onOpenWorkoutTracker} className="track-workout-btn">
        📊 Track Progress
      </button>
    </div>
  );
}

export default QuickActions;
